import log, { LogLevel } from 'shared/utils/log';
export interface NativeMessage {
  type: string;
  data?: any;
}

export function addNativeMessageListener(cb: (msg: NativeMessage) => void) {
  const handler: any = (ev: CustomEvent) => {
    cb(ev.detail);
  };
  window.addEventListener('sb:nativemessage', handler);
  return () => window.removeEventListener('sb:nativemessage', handler);
}

export function nativeLogout() {
  sendNativeMessage({ type: 'LOGOUT' });
}

export function nativeOpenURL(url: string) {
  sendNativeMessage({ type: 'OPEN_URL', data: { url } });
}

export function nativeReload() {
  sendNativeMessage({ type: 'RELOAD' });
}

export function nativeLog(
  type: LogLevel,
  message: string,
  object?: Object,
  error?: Error,
) {
  // Check first to avoid noisy logging in non-native contexts
  if ((window as any).ReactNativeWebView?.postMessage) {
    sendNativeMessage({
      type: 'LOG',
      data: {
        type,
        message,
        object,
        error: error?.toString(),
      },
    });
  }
}

function sendNativeMessage(msg: NativeMessage) {
  /**
   * A note about window.ReactNativeWebView.postMessage; DO NOT assign it to a
   * local variable for convenience e.g.
   *
   * const postMessage = (window as any).ReactNativeWebView?.postMessage;
   *
   * This causes it to break since it uses native bindings!!! You'll get error
   * "java bridge method can't be invoked on a non injected object."
   */
  try {
    if (!(window as any).ReactNativeWebView?.postMessage) {
      log.error('sendNativeMessage called in context without window.ReactNativeWebView!');
      return;
    }
    (window as any).ReactNativeWebView?.postMessage(JSON.stringify(msg));
  } catch (err) {
    log.error('Error sending native message', msg, err);
  }
}
